import { Locale } from '@core/constants/locales.constants';
import { ARTICLE_FORMATS } from '@core/types/pages/articlePage.types';
import { ArticlePromo } from '@graphql/__generated__/graphql';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { ArticlePromoBlockProps } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import templateConfig from '@templateConfig';
import { generateFullPathname } from '@utils/paths/generateFullPathname.utils';

export type ArticlePromoTransformSettings = {
  locale: Locale;
  dictionary: {
    readNewsArticle: Translations['news']['label']['readNewsArticle'];
    viewGalleryArticle: Translations['news']['label']['viewGalleryArticle'];
    watchVideoArticle: Translations['news']['label']['watchVideoArticle'];
  };
};

const articlePromoTransform = (
  { id, article, label }: CleanContentful<ArticlePromo>,
  { locale, dictionary }: ArticlePromoTransformSettings
): ArticlePromoBlockProps => {
  const ctaLabel = () => {
    switch (article?.format) {
      case ARTICLE_FORMATS.NEWS: {
        return dictionary.readNewsArticle;
      }
      case ARTICLE_FORMATS.VIDEO: {
        return dictionary.watchVideoArticle;
      }
      case ARTICLE_FORMATS.GALLERY: {
        return dictionary.viewGalleryArticle;
      }
      default: {
        return dictionary.readNewsArticle;
      }
    }
  };

  return {
    id,
    title: article?.articleTitle || '',
    summary: article?.summary || '',
    label,
    ctaButton: {
      variant: 'text-button',
      text: ctaLabel(),
      url: generateFullPathname({
        locale,
        route: templateConfig.navigation.routes.ARTICLE,
        params: { article: article?.slug },
      }),
    },
    image: article?.image ? (
      <ContentfulImage {...article.image} />
    ) : (
      <ContentfulImage
        alt="Placeholder Image"
        width={420}
        height={360}
        url="https://images.ctfassets.net/qpz2vl40uleh/5t4ugdlfydzHls9NEfUAn5/80283eedacf3c4a8ef85a44a5209d2b6/y9DpT.jpeg"
      />
    ),
  };
};

export default articlePromoTransform;
